<template>
  <div class="flex mb-4 gap-4 items-center">
    <!-- Card with item details and quantity -->
    <div
      class="flex justify-between items-center py-2 px-3 flex-1"
      :class="{
        'border-action bg-white': item.amount > 0,
        'border-gray-200 bg-white': item.amount === 0
      }"
    >
      <!-- Item details -->
      <div class="flex-1">
        <div class="text-normal-emphasis font-medium">{{ item.name }}</div>
        <div class="text-normal-reduced">Other</div>
      </div>

    </div>

    <!-- Price outside the border -->
    <div class="w-[120px] text-right text-normal-emphasis font-medium">
      <AppInputCurrency :name="`donation-${item.itemId}`" :text-right="true" :isFullWidth="true" currency="usd" :model-value="modelValue" @update:model-value="(val) => updateDonation(val)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AppSelect from '@/components/AppSelect.vue';
import { SelectOption } from '@/models/SelectOption';
import useLocalization from '@/modules/useLocalization';
import { Item } from '@models/Item';
import AppInput from './AppInput.vue';

const { formatCurrency } = useLocalization();

interface Props {
  item: Item;
  modelValue: number;
}

defineProps<Props>();

const emit = defineEmits(['update:modelValue']);


// Method to set the quantity directly
const updateDonation = (value: number) => {
  emit('update:modelValue', value);
};
</script>
